import React from "react";
import NewNavbar from "components/NavBar/NewNavbar";
import { Outlet } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { sandooqTheme } from "themes/sandooqTheme";
import { ToastProvider } from "components/shared/components/ToastContext";
import { ErrorBoundary } from "components/shared/components/ErrorBoundary";

const Layout = () => (
  <ThemeProvider theme={sandooqTheme}>
    <CssBaseline />
    <ToastProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <NewNavbar />
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </LocalizationProvider>
    </ToastProvider>
  </ThemeProvider>
);

export default Layout;
